import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Search, X } from 'react-bootstrap-icons';
import { FaPlus, FaMousePointer, FaTimes } from 'react-icons/fa';
import HierarchicalTable from './components/HierarchicalTable/HierarchicalTable';
import { getAllParentsCategoriesByLocalId, getSubCategoriesByCategoryId } from '../../../../crud/menu_api/categories';
import { ParentsCategorys, SubCategoryType } from './types';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import '../../../../styles/Table.scss';
import './Categories.scss';

const Puesto: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [filteredCategories, setFilteredCategories] = useState<ParentsCategorys[]>([]);
  const [originalCategories, setOriginalCategories] = useState<ParentsCategorys[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectMode, setSelectMode] = useState(false);
  const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);

  useEffect(() => {
    const userContext = localStorage.getItem('user');
    const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
    getAllParentsCategoriesByLocalId(localId)
      .then(response => {
        setFilteredCategories(response.data);
        setOriginalCategories(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching categories:", error.response || error.message);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredCategories(originalCategories);
      return;
    }

    const searchCategories = async () => {
      const lowerSearch = searchTerm.toLowerCase();
      const results: ParentsCategorys[] = [];
      const addedIds = new Set<number>();

      for (const parent of originalCategories) {
        const parentMatches = parent.category_name.toLowerCase().includes(lowerSearch);

        if (parentMatches && !addedIds.has(parent.category_id)) {
          results.push(parent);
          addedIds.add(parent.category_id);
        }

        if (parent.isParent) {
          try {
            const response = await getSubCategoriesByCategoryId(parent.category_id);
            const subcategories: SubCategoryType[] = response.data;

            const matchingSubcategories = subcategories.filter(sub =>
              sub.category_name.toLowerCase().includes(lowerSearch)
            );

            matchingSubcategories.forEach(sub => {
              if (!addedIds.has(sub.category_id)) {
                results.push({
                  ...sub,
                  isParent: false,
                  isEmpty: sub.isEmpty ?? true,
                  menus: []
                });
                addedIds.add(sub.category_id);
              }
            });
          } catch (error) {
            console.error(`Error fetching subcategories for ${parent.category_name}:`, error);
          }
        }
      }

      setFilteredCategories(results);
    };

    searchCategories();
  }, [searchTerm, originalCategories]);



  const renderHeader = () => (
    <div className="mp-page-header-container">
      <h2 className="title">Categorías</h2>
      <div className="buttons">
      </div>
    </div>
  );


  if (loading) {
    return <LoadingSpinner text="Cargando Categorías" transparent={true} />;
  }


  return (
    <div className="categories-container">
      {renderHeader()}

      {/* Search and Actions Bar */}
      <div className="categories-filter-card">
        <div className="categories-search-bar">
          {!searchTerm && <Search className="search-icon" />}
          <input
            type="text"
            className="search-input"
            placeholder="Buscar categorías..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button 
              className="clear-search-btn"
              onClick={() => setSearchTerm('')}
              aria-label="Limpiar búsqueda"
            >
              <X />
            </button>
          )}
        </div>

        <Button 
          variant='none' 
          className="filter-button create-category-button"
          onClick={() => setShowCreateCategoryModal(true)}
        >
          <FaPlus className="me-2" /> Crear categoría
        </Button>

        <Button
          variant='none'
          className="filter-button selection-button"
          onClick={() => setSelectMode(prev => !prev)}
        >
          {selectMode ? (
            <><FaTimes className="me-2" /> Cancelar</>
          ) : (
            <><FaMousePointer className="me-2" /> Seleccionar</>
          )}
        </Button>
      </div>

      <HierarchicalTable
        categories={filteredCategories}
        setCategories={setFilteredCategories}
        originalCategories={originalCategories}
        setOriginalCategories={setOriginalCategories}
        setSearchTerm={setSearchTerm}
        selectMode={selectMode}
        setSelectMode={setSelectMode}
        showCreateCategoryModal={showCreateCategoryModal}
        setShowCreateCategoryModal={setShowCreateCategoryModal}
      />
    </div>
  );
};

export default Puesto;
